export default "__VITE_ASSET__BbGeHKJT__"